import * as ngCore from '@angular/core'

/**
 * Used as inner component to design system.
 * It wraps component / content and adds label and loading indicator. to it
 *
 * **Inputs**
 * - {@link AtnDsLabelComponent.label|label}?
 * - {@link AtnDsLabelComponent._loading|loading}?
 *
 * @example
 * ```html
 * <atn-ds-label [label]="'Label'" [loading]="false">
 *   <atn-ds-text></atn-ds-text>
 * </atn-ds-label>
 */
@ngCore.Component({
  selector: 'atn-ds-label',
  standalone: true,
  styleUrls: ['./label.component.scss'],
  templateUrl: './label.component.html',
})
export class AtnDsLabelComponent {
  /**
   * Label text
   */
  public labelSg = ngCore.input<string | undefined>('', { alias: 'label' })

  /**
   *Indicates whether the input is loading to present loader
   */
  public loadingSg = ngCore.input<boolean | undefined>(false, {
    alias: 'loading',
  })
}
